import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 32,
    padding: '48px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    maxWidth: 320,
    minHeight: 360,
    boxSizing: 'border-box'
  },
  cardTitle: {
    fontSize: '1.9rem',
    maxWidth: 200,
    fontWeight: 600,
    color: '#111111',
    marginBottom: 24,
    fontFamily: 'sans-serif'
  },
  cardText: {
    fontSize: '1.05rem',
    lineHeight: 1.6,
    color: '#111111',
    marginBottom: 40,
    fontWeight: 500,
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 12
  },
  buttonLink: {
    textDecoration: 'none',
    width: '100%',
    maxWidth: 260,
    display: 'flex',
    justifyContent: 'center'
  }
}))
